<template>
  <div class="admin-coop-content">
    <nuxt />
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  mounted () {
    this.$store.dispatch('app/SET_IS_MIGRATED', true)
  }
}
</script>

<style>
</style>
